import { render, staticRenderFns } from "./property-setting-view-toolbar.vue?vue&type=template&id=2b0c8082&"
import script from "./property-setting-view-toolbar.vue?vue&type=script&lang=js&"
export * from "./property-setting-view-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports